import script from "./Gifts.vue?vue&type=script&setup=true&lang=js"
export * from "./Gifts.vue?vue&type=script&setup=true&lang=js"

import "./Gifts.vue?vue&type=style&index=0&id=4b670f06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b670f06"]])

export default __exports__